module.exports = __webpack_public_path__ + "img/search-icon-white.bb6360b9.svg";